import Papa from "papaparse";

export type SingleColumnCsvResult =
    { values: string[]; error?: undefined } | { values?: undefined; error: "MULTIPLE_COLUMNS" | "INVALID_QUOTES" };

// Suitable for any "single CSV column, one value per row" import. Each value is a single line:
// any whitespace run, including a line break inside a quoted cell, collapses to one space.
// A blank row is real content and is kept at its original position.
export function parseSingleColumnCsv(csvText: string): SingleColumnCsvResult {
    // Fixed delimiter rather than auto-detected: a single column has no delimiter to detect,
    // so library's guess would split options that all happen to contain the same `;` or tab.
    const { data, errors } = Papa.parse<string[]>(csvText, { delimiter: ",", skipEmptyLines: false });
    // With the delimiter fixed and no header row, papaparse's only possible errors are quote errors
    // (an unclosed quote, or text after a closing quote).
    if (errors.length > 0) return { error: "INVALID_QUOTES" };

    const rows = [...data];
    if (/(\r\n|\r|\n)$/.test(csvText) && rows.at(-1)?.every(cell => cell === "")) rows.pop();

    if (rows.some(cells => cells.slice(1).some(cell => cell.trim() !== ""))) {
        return { error: "MULTIPLE_COLUMNS" };
    }
    return { values: rows.map(cells => cells[0].replace(/\s+/g, " ").trim()) };
}
